<template>
  <div>
    <div class="container pageBody">
      <div class="d-none d-md-block">
        <StudioSwiper :images="images" />
      </div>
      <div class="d-block d-md-none studioDetailHeader">
        <ImageSlider :images="images" :isList="false" />
      </div>
    </div>
    <div id="pos">
      <div id="sticky">
        <div class="container h-100">
          <div class="row h-100">
            <div class="col-12 col-md-8 col-xl-6">
              <div class="d-flex align-items-center justify-content-between h-100">
                <div>
                  <div class="thumbnailArea">
                    <div class="thumbnail" :style="`background:url(${thumbnailUrl}) center / cover;aspect-ratio: 1 / 1;`"></div>
                  </div>
                  <h1 class="studioName">{{ studioInfo.studio_name }}</h1>
                  <div class="studioTags">
                    <a v-for="item in studioTagInfo" :key="item.tag_id" :href="`/studio-list/?search_tag=${item.tag_id}`"> #{{ item.name }} </a>
                  </div>
                </div>
                <div v-if="studioInfo.contact_line_flg == 1" class="h-100 d-flex align-items-center d-md-none">
                  <a href="https://lin.ee/yI0t56I">
                    <img :src="lineIconUrl" class="lineIcon" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-6 d-none d-xl-block">
              <div class="d-flex align-items-center justify-content-end h-100">
                <!-- <div class="contactTell">
                  <a v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                    {{ studioInfo.contact_tel }}
                  </a>
                  <a v-else href="tel:03-5545-5523"> 03-5545-5523 </a>
                  <span class="contactTellHover">
                    <a v-if="studioInfo.contact_tel" @click="copy(studioInfo.contact_tel, 'copyTell')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else @click="copy('03-5545-5523', 'copyTell')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else href="tel:03-5545-5523">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <span id="copyTell" class="copyOk">Copy</span>
                  </span>
                </div> -->
                <div class="contactMail">
                  <a v-if="studioInfo.contact_url" target="_blank" :href="studioInfo.contact_url"> お問い合わせフォーム </a>
                  <a v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                    <span>
                      {{ studioInfo.contact_mail }}
                    </span>
                  </a>
                  <a v-else @click="click" class="trigger"> お問い合わせはこちら </a>
                  <span class="contactMailHover">
                    <a v-if="studioInfo.contact_url" @click="copy(studioInfo.contact_url, 'copyMail')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else-if="studioInfo.contact_mail" @click="copy(studioInfo.contact_mail, 'copyMail')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-if="studioInfo.contact_url" target="_blank" :href="studioInfo.contact_url">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else @click="click" class="trigger">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <span id="copyMail" class="copyOk">Copy</span>
                  </span>
                </div>
                <div v-if="studioInfo.contact_line_flg == 1">
                  <a href="https://lin.ee/yI0t56I">
                    <img :src="lineIconUrl" class="lineIcon" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-4 d-none d-md-block d-xl-none">
              <div class="d-flex justify-content-end h-100">
                <div class="text-right d-flex align-items-center">
                  <div>
                    <!-- <a class="contactTell" v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                      {{ studioInfo.contact_tel }}
                    </a>
                    <a class="contactTell" v-else href="tel:03-5545-5523"> 03-5545-5523 </a> -->
                    <a class="contactMail" v-if="studioInfo.contact_url" :href="studioInfo.contact_url" target="_blank"> お問い合わせフォーム </a>
                    <a class="contactMail" v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                      <span>{{ studioInfo.contact_mail }}</span>
                    </a>
                    <a class="contactMail trigger" v-else @click="click"> お問い合わせはこちら </a>
                  </div>
                </div>
                <div v-if="studioInfo.contact_line_flg == 1" class="h-100 d-flex align-items-center">
                  <a href="https://lin.ee/yI0t56I">
                    <img :src="lineIconUrl" class="lineIcon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="stickyFloating">
        <div class="container h-100 pl-0">
          <div class="row h-100">
            <div class="col-12 col-md-8 col-xl-6 d-none d-md-block">
              <div class="d-flex align-items-center h-100">
                <div class="d-flex justify-content-start">
                  <div class="thumbnailArea">
                    <div class="thumbnail" :style="`background:url(${thumbnailUrl}) center / cover;aspect-ratio: 1 / 1;`"></div>
                  </div>
                  <div class="pl-3 d-flex align-items-center">
                    <div>
                      <h1 class="studioName">{{ studioInfo.studio_name }}</h1>
                      <div class="studioTags">
                        <a v-for="item in studioTagInfo" :key="item.tag_id" :href="`/studio-list/?search_tag=${item.tag_id}`"> #{{ item.name }} </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 d-none d-xl-block">
              <div class="d-flex align-items-center justify-content-end h-100">
                <!-- <div class="contactTell">
                  <a v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                    {{ studioInfo.contact_tel }}
                  </a>
                  <a v-else href="tel:03-5545-5523"> 03-5545-5523 </a>
                  <span class="contactTellHover">
                    <a v-if="studioInfo.contact_tel" @click="copy(studioInfo.contact_tel, 'footerCopyTell')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else @click="copy('03-5545-5523', 'footerCopyTell')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else href="tel:03-5545-5523">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <span id="footerCopyTell" class="copyOk">Copy</span>
                  </span>
                </div> -->
                <div class="contactMail">
                  <a v-if="studioInfo.contact_url" target="_blank" :href="studioInfo.contact_url"> お問い合わせフォーム </a>
                  <a v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                    <span>
                      {{ studioInfo.contact_mail }}
                    </span>
                  </a>
                  <a v-else @click="click" class="trigger"> お問い合わせはこちら </a>
                  <span class="contactMailHover">
                    <a v-if="studioInfo.contact_url" @click="copy(studioInfo.contact_url, 'footerCopyMail')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-else-if="studioInfo.contact_mail" @click="copy(studioInfo.contact_mail, 'footerCopyMail')">
                      <img class="studioHoverCopy" :src="`${imgPath}/images/hoverCopy.svg`" />
                    </a>
                    <a v-if="studioInfo.contact_url" target="_blank" :href="studioInfo.contact_url">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <a v-else @click="click" class="trigger">
                      <img class="studioHoverLink" :src="`${imgPath}/images/hoverLink.svg`" />
                    </a>
                    <span id="footerCopyMail" class="copyOk">Copy</span>
                  </span>
                </div>
                <div v-if="studioInfo.contact_line_flg == 1">
                  <a href="https://lin.ee/yI0t56I">
                    <img :src="lineIconUrl" class="lineIcon" />
                  </a>
                </div>
              </div>
            </div>
            <div class="col-4 d-none d-md-block d-xl-none">
              <div class="d-flex justify-content-end h-100">
                <div class="text-right d-flex align-items-center">
                  <div>
                    <!-- <a class="contactTell" v-if="studioInfo.contact_tel" :href="`tel:${studioInfo.contact_tel}`">
                      {{ studioInfo.contact_tel }}
                    </a>
                    <a class="contactTell" v-else href="tel:03-5545-5523"> 03-5545-5523 </a> -->
                    <a class="contactMail" v-if="studioInfo.contact_url" :href="studioInfo.contact_url" target="_blank"> お問い合わせフォーム </a>
                    <a class="contactMail" v-else-if="studioInfo.contact_mail" :href="`mailto:${studioInfo.contact_mail}`">
                      <span>{{ studioInfo.contact_mail }}</span>
                    </a>
                    <a class="contactMail trigger" v-else @click="click"> お問い合わせはこちら </a>
                  </div>
                  <div v-if="studioInfo.contact_line_flg == 1" class="h-100 d-flex align-items-center">
                    <a href="https://lin.ee/yI0t56I">
                      <img :src="lineIconUrl" class="lineIcon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-md-none w-100">
              <div class="d-flex align-items-center h-100">
                <div class="thumbnailArea">
                  <div class="thumbnail" :style="`background:url(${thumbnailUrl}) center / cover;aspect-ratio: 1 / 1;`"></div>
                </div>
                <h1 class="studioName mr-auto">{{ studioInfo.studio_name }}</h1>
                <div v-if="studioInfo.contact_line_flg == 1" style="width: 60px">
                  <a href="https://lin.ee/yI0t56I">
                    <img :src="lineIconUrl" class="lineIcon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot name="content" />
    <div id="mobileFooterBtn" class="d-md-none d-flex justify-content-end mobileFooterBtn">
      <!-- <a v-if="studioInfo.contact_tel" class="contactTell" :href="`tel:${studioInfo.contact_tel}`">
        {{ studioInfo.contact_tel }}
      </a>
      <a v-else class="contactTell" href="tel:03-5545-5523"> 03-5545-5523 </a> -->
      <a v-if="studioInfo.contact_url" class="studioDetailButton" target="_blank" :href="studioInfo.contact_url"> お問い合わせフォーム </a>
      <a v-else-if="studioInfo.contact_mail" class="studioDetailButton" :href="`mailto:${studioInfo.contact_mail}`">
        <span> メールで問い合わせる </span>
      </a>
      <a v-else class="studioDetailButton trigger" @click="click"> お問い合わせはこちら </a>
    </div>
    <transition name="fade">
      <ContactForm
        v-if="isOpen"
        @close="click"
        :nonce="nonce"
        :studioId="studioInfo.studio_id"
        :studioName="studioInfo.studio_name"
        :imgPath="imgPath"
        :postUrl="postUrl"
      />
    </transition>
  </div>
</template>
<script>
import StudioSwiper from "../StudioSwiper/StudioSwiper.vue";
import ContactForm from "../../components/ContactForm.vue";
import ImageSlider from "../../components/ImageSlider.vue";

export default {
  name: "StudioDetail",
  components: { StudioSwiper, ContactForm, ImageSlider },
  props: {
    studioInfoData: {
      type: String,
      require: true,
    },
    studioTagInfoData: {
      type: String,
      require: true,
    },
    studioImageUrlsJoined: {
      type: String,
      require: true,
    },
    thumbnailUrl: {
      type: String,
      require: true,
    },
    lineIconUrl: {
      type: String,
      require: true,
    },
    imgPath: {
      type: String,
      require: true,
    },
    nonce: {
      type: String,
      require: true,
    },
    postUrl: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      isOpen: false,
      scrollTop: 0,
      scrollpos: 0,
    };
  },
  computed: {
    studioInfo() {
      return JSON.parse(this.studioInfoData);
    },
    studioTagInfo() {
      return JSON.parse(this.studioTagInfoData);
    },
    images() {
      return this.studioImageUrlsJoined ? this.studioImageUrlsJoined.split(",") : [];
    },
  },
  mounted() {
    // console.log(this.studioInfo);
    // console.log(this.studioImageUrlsJoined);
  },
  methods: {
    copy(item, value) {
      document.getElementById(value).style.display = "initial";
      setTimeout(() => {
        document.getElementById(value).style.display = "none";
      }, 500);
      navigator.clipboard.writeText(item);
    },
    click() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.bodyFixedOn();
      } else {
        this.bodyFixedOff();
      }
    },
    bodyFixedOn() {
      this.scrollpos = window.scrollY;
      this.scrollTop = -window.scrollY + "px";
      document.body.style.position = "fixed";
      document.body.style.top = this.scrollTop;
    },
    bodyFixedOff() {
      document.body.removeAttribute("style");
      scrollTo(0, this.scrollpos);
    },
  },
};
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  will-change: opacity;
  transition: opacity 0.1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.trigger {
  cursor: pointer;
}

.mobileFooterBtn {
  margin-left: -0;
}
</style>
